<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <span
            class="header-span"
            :class="{ 'header-span-active': active == 1 }"
            @click="active = 1"
            >{{ $t("m.options.listTab.time") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active == 2 }"
            @click="active = 2"
            >{{ $t("m.options.listTab.name") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active == 3 }"
            @click="active = 3"
            >{{ $t("m.options.listTab.inventory") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active == 4 }"
            @click="active = 4"
            >按常用</span
          >
        </div>
        <div class="box-header-right">
          <el-button
            type="primary"
            icon="el-icon-search"
            class="active-icon"
            @click="dialogTableVisible = true"
          ></el-button>
          <el-button type="primary" icon="el-icon-delete" class="active-icon"
            >删除</el-button
          >
          <el-button type="primary" icon="el-icon-plus" class="active-icon"
            >新建</el-button
          >
        </div>
      </div>
      <!--内容-->
      <div class="box-content" v-if="active == 1">
        <div class="box-item box-half box-active">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x.png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span>
              <span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
      </div>
      <div class="box-content" v-if="active == 2">
        <div class="box-item box-half box-active">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x.png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span>
              <span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
      </div>
      <div class="box-content" v-if="active == 3">
        <div class="box-item box-half box-active">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x.png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span>
              <span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
      </div>
      <div class="box-content" v-if="active == 4">
        <div class="box-item box-half box-active">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x.png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span>
              <span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
        <div class="box-item box-half">
          <div class="box-item-img">
            <img src="../../assets/img/咖啡豆@2x(1).png" />
            <div class="datetime">2020.07.25</div>
          </div>
          <div class="box-item-text">
            <div>
              <span class="text-title">名字：</span
              ><span class="text-value">铁皮卡</span>
            </div>
            <div>
              <span class="text-title">等级：</span
              ><span class="text-value">Caracoil</span>
            </div>
            <div>
              <span class="text-title">处理方式：</span
              ><span class="text-value">水洗</span>
            </div>
            <div>
              <span class="text-title">重量：</span
              ><span class="text-value">850 kg</span>
            </div>
          </div>
        </div>
      </div>
      <div class="main-box-footer">
        <span>总重量：1200kg | 种类：4种</span>
      </div>
    </div>
    <div class="main-box border-1px-all">
      <section>
        <div class="flex flex-between">
          <div class="title-bc">生豆详情</div>
          <div class="line-right">
            <el-button type="warning">{{
              $t("m.commentDetail.saveChange")
            }}</el-button>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 100%">
            <span class="cus-input-title">重量</span>
            <el-input placeholder="" type="text" v-model="name"> </el-input>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">名称</span>
            <el-input placeholder="" type="text" v-model="name"> </el-input>
          </div>
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">豆种</span>
            <el-select v-model="bean" :placeholder="$t('m.table.select')">
              <el-option
                v-for="item in been_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">国家</span>
            <el-input placeholder="" type="text" v-model="name"> </el-input>
          </div>
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">处理</span>
            <el-select v-model="deal" :placeholder="$t('m.table.select')">
              <el-option
                v-for="item in deal_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">产区</span>
            <el-input placeholder="" type="text" v-model="name"> </el-input>
          </div>
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">等级</span>
            <el-select v-model="level" :placeholder="$t('m.table.select')">
              <el-option
                v-for="item in level_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">庄园</span>
            <el-input placeholder="" type="text" v-model="name"> </el-input>
          </div>
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">海拔</span>
            <el-input placeholder="" type="text" v-model="name"> </el-input>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">供应商</span>
            <el-input placeholder="" type="text" v-model="name"> </el-input>
          </div>
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">价格</span>
            <el-input placeholder="" type="text" v-model="name"> </el-input>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">联系方式</span>
            <el-input placeholder="" type="text" v-model="name"> </el-input>
          </div>
          <div class="flex input-wrap has-title" style="width: 45%">
            <span class="cus-input-title">产季</span>
            <el-date-picker
              v-model="season"
              type="date"
              prefix-icon="none"
              :clearable="false"
              :placeholder="$t('m.table.selectDate')"
            >
            </el-date-picker>
          </div>
        </div>
      </section>

      <section>
        <div class="header-common flex flex-center" style="margin-top: 10px;">
          <span class="header-span header-span-active">曲线列表</span>
        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column prop="name" :label="$t('m.table.name')">
          </el-table-column>
          <el-table-column
            prop="time"
            :label="$t('m.table.duration')"
            width="60"
          >
          </el-table-column>
          <el-table-column prop="date" :label="$t('m.table.date')" width="100">
          </el-table-column>
          <el-table-column
            prop="star"
            :label="$t('m.table.starLevel')"
            width="150"
          >
            <template slot-scope="scope">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="scope.row.star"
              ></el-rate>
            </template>
          </el-table-column>
          <el-table-column :label="$t('m.table.operation')" width="80">
            <template>
              <el-button
                type="text"
                size="mini"
                style="color: white"
                @click="dialogTableVisible2 = true"
              >
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          align="right"
          layout="prev, pager, next"
          style="margin-top: 10px"
          :total="200"
        >
        </el-pagination>
      </section>
    </div>
    <!--------曲线详情---------->
    <el-dialog
      :title="$t('m.deviceManage.bindDevice.operation.detail')"
      :visible.sync="dialogTableVisible2"
    >
      <section>
        <div class="flex flex-center header-common">
          <span class="header-span header-span-active">曲线详情</span>
        </div>
        <el-table
          :data="gridData3"
          border
          style="width:100%;"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column
            property="key1"
            :label="$t('m.table.name')"
          ></el-table-column>
          <el-table-column property="key2" label="类别"></el-table-column>
          <el-table-column property="key3" label="事件"></el-table-column>
          <el-table-column property="key4" label="时间"></el-table-column>
          <el-table-column property="key5" label="重量"></el-table-column>
        </el-table>
        <div class="table-totla-line">
          <span class="gray-text">总重量:</span>
          <span class="white-text">650kg</span>
        </div>
      </section>
      <section>
        <div class="flex flex-center header-common">
          <span class="header-span header-span-active">描述</span>
        </div>
        <div class="row-box">
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">序列号：</span>
                <span class="white-text">23213123123</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">机器型号：</span>
                <span class="white-text">43242</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">烘焙时长：</span>
                <span class="white-text"></span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">发展时间：</span>
                <span class="white-text">2021.06.01</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">发展率：</span>
                <span class="white-text">15</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">入豆温：</span>
                <span class="white-text">生豆一</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">回温点：</span>
                <span class="white-text">导入</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">转黄点：</span>
                <span class="white-text">540kg</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">一爆：</span>
                <span class="white-text">340</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">二爆：</span>
                <span class="white-text">540kg</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">结束：</span>
                <span class="white-text">Light:8</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">回温至黄点温升：</span>
                <span class="white-text"></span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">黄点至一爆温升：</span>
                <span class="white-text">Light:8</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text">一爆至结束温升：</span>
                <span class="white-text"></span>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
      <section>
        <div class="flex flex-center header-common">
          <span class="header-span header-span-active">过程</span>
        </div>
        <el-table
          :data="gridData2"
          border
          style="width:100%;"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column
            property="key1"
            width="60px"
            label="时间"
          ></el-table-column>
          <el-table-column
            property="key2"
            width="60px"
            label="豆温"
          ></el-table-column>
          <el-table-column
            property="key3"
            width="60px"
            label="ROR"
          ></el-table-column>
          <el-table-column
            property="key4"
            width="70px"
            label="热风温"
          ></el-table-column>
          <el-table-column
            property="key5"
            width="70px"
            label="出风温"
          ></el-table-column>
          <el-table-column
            property="key6"
            width="70px"
            label="环境温"
          ></el-table-column>
          <el-table-column
            property="key7"
            width="60px"
            label="火力"
          ></el-table-column>
          <el-table-column
            property="key8"
            width="60px"
            label="热风"
          ></el-table-column>
          <el-table-column
            property="key9"
            width="60px"
            label="滚筒"
          ></el-table-column>
          <el-table-column property="key10" label="标记"></el-table-column>
        </el-table>
      </section>
      <section>
        <div class="flex" style="justify-content:flex-end;margin-top:20px;">
          <div class="line-right">
            <el-button type="primary">导出PDF</el-button>
            <el-button type="primary">导出JSON</el-button>
          </div>
        </div>
      </section>
    </el-dialog>
    <!--------搜索弹框---------->
    <el-dialog
      title="搜索"
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="false"
    >
      <div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按序列号</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按用户名</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按手机号</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">按地址</span>
          <el-input placeholder="请输入"> </el-input>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="dialogTableVisible = false" class="dialog-footer-btn">
          {{ $t("m.chart.table.cancel") }}
        </div>
        <div
          type="primary"
          @click="dialogTableVisible = false"
          class="dialog-footer-btn"
        >
          {{ $t("m.chart.table.confirm") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "equipment-list",
  data() {
    return {
      active: 1,
      active1: 1,
      bean: "",
      deal: "",
      level: "",
      season: "",
      been_options: [
        {
          value: "b1",
          label: "豆种一",
        },
        {
          value: "b2",
          label: "豆种二",
        },
        {
          value: "b3",
          label: "豆种仨",
        },
        {
          value: "b4",
          label: "豆种四",
        },
      ],
      deal_options: [
        {
          value: "d1",
          label: "半水洗",
        },
        {
          value: "d2",
          label: "水洗",
        },
      ],
      level_options: [
        {
          value: "l1",
          label: "AA Plus-plus",
        },
        {
          value: "l2",
          label: "A Plus-plus",
        },
        {
          value: "l3",
          label: "BB Plus-plus",
        },
      ],
      name: "",
      date: "",
      selectValue: "",
      sliderValue: 30,
      num1: 3,
      num2: 0,
      num3: 0,
      dialogTableVisible: false,
      dialogTableVisible2: false,
      gridData2: [
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
        {
          key1: "00:00",
          key2: "10℃",
          key3: "10℃",
          key4: "10℃",
          key5: "10℃",
          key6: "10℃",
          key7: "30",
          key8: "30",
          key9: "30",
          key10: "空",
        },
      ],
      gridData3: [
        {
          key1: "卡图拉",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "新世界",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "斯考特实验室精选",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "法国传教士",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
        {
          key1: "铁皮卡",
          key2: "Grade2",
          key3: "密处理",
          key4: "2021.06.25",
          key5: "850kg",
        },
      ],
      tableData: [
        {
          name: "导入曲线",
          time: "20:25",
          date: "2016-05-03",
          star: 3,
        },
        {
          name: "导入曲线",
          time: "20:25",
          date: "2016-05-03",
          star: 3,
        },
        {
          name: "导入曲线",
          time: "20:25",
          date: "2016-05-03",
          star: 3,
        },
        {
          name: "导入曲线",
          time: "20:25",
          date: "2016-05-03",
          star: 3,
        },
        {
          name: "导入曲线",
          time: "20:25",
          date: "2016-05-03",
          star: 3,
        },
        {
          name: "导入曲线",
          time: "20:25",
          date: "2016-05-03",
          star: 3,
        },
        {
          name: "导入曲线",
          time: "20:25",
          date: "2016-05-03",
          star: 3,
        },
      ],
    };
  },
  methods: {
    handleChange() {},
  },
};
</script>

<style scoped>
.el-select {
  width: 100%;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

.box-item .box-item-img img {
  width: 65px;
}
</style>
